var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStrikeText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 4.39469C13.75 3.20546 13.0367 2.32638 12.1331 1.78943C11.2383 1.25765 10.0909 1.00979 8.97532 1.04652C7.85886 1.08328 6.69283 1.40816 5.78767 2.11679C4.85822 2.84444 4.25 3.94438 4.25 5.39469C4.25 5.99979 4.35604 6.53351 4.56554 6.99986H6.40749C6.23605 6.85694 6.10073 6.69736 5.99874 6.51452C5.85234 6.25208 5.75 5.89763 5.75 5.39469C5.75 4.41098 6.14178 3.74456 6.71233 3.29789C7.30717 2.83221 8.14114 2.5748 9.02468 2.54571C9.90906 2.51659 10.7617 2.71931 11.3669 3.07892C11.9633 3.43337 12.25 3.8865 12.25 4.39469C12.25 4.8089 12.5858 5.14469 13 5.14469C13.4142 5.14469 13.75 4.8089 13.75 4.39469ZM13.5585 10.9999H11.924C12.128 11.3287 12.25 11.7582 12.25 12.3488C12.25 13.4219 11.8421 14.1821 11.2548 14.6985C10.6508 15.2295 9.81797 15.5343 8.95322 15.5883C8.08531 15.6425 7.2563 15.44 6.66787 15.0452C6.102 14.6655 5.75 14.1095 5.75 13.3488C5.75 12.9346 5.41421 12.5988 5 12.5988C4.58579 12.5988 4.25 12.9346 4.25 13.3488C4.25 14.6635 4.898 15.664 5.83213 16.2908C6.7437 16.9024 7.91469 17.1561 9.04678 17.0854C10.182 17.0144 11.3492 16.6129 12.2452 15.825C13.1579 15.0224 13.75 13.8511 13.75 12.3488C13.75 11.8444 13.6828 11.3968 13.5585 10.9999Z",
    fill: "#242424"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 9H16",
    stroke: "#242424",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

export default SvgStrikeText;